import { render, staticRenderFns } from "./TopOrganisers.vue?vue&type=template&id=4f99ba1c&scoped=true&"
import script from "./TopOrganisers.vue?vue&type=script&lang=js&"
export * from "./TopOrganisers.vue?vue&type=script&lang=js&"
import style0 from "./TopOrganisers.vue?vue&type=style&index=0&id=4f99ba1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f99ba1c",
  null
  
)

export default component.exports